import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import { useFetch } from "../hooks/useFetch";
import moment from "moment";
import LinesEllipsis from "react-lines-ellipsis";
import Skeleton from "react-loading-skeleton";
import Loading from "../components/Loading";
import HeaderImg from "../components/HeaderImg";

const News = () => {
  const [page, setPage] = useState(1);
  const [blogs, setBlogs] = useState(null);

  const [searchParams] = useSearchParams();
  const tagUrl = searchParams.get("tag");

  const { data, loading, refetch } = useFetch(
    `/blog/all/${page}/15/${tagUrl ? tagUrl : "all"}`,
  );
  const { data: tags, loading: tagLoading } = useFetch(`/tag/all`);

  useEffect(() => {
    // console.log("tagUrl", tagUrl);
    setPage(1);
    setBlogs(null);
  }, [tagUrl]);

  useEffect(() => {
    if (page > 1) {
      //   refetch();
    }
  }, [page]);

  useEffect(() => {
    if (loading === false) {
      if (data?.blogs?.length > 0 && blogs === null) {
        setBlogs(data?.blogs);
      }
      if (blogs?.length > 0 && page > blogs?.length / 12) {
        setBlogs((curr) =>
          curr?.length > 0 ? [...curr, ...data?.blogs] : [...data?.blogs],
        );
      }
    }
  }, [loading]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // const tags = [
  //   { name: "All", url: "" },
  //   { name: "Sports betting", url: "sport_betting" },
  //   { name: "Casino", url: "casino" },
  //   { name: "Crypto", url: "crypto" },
  //   { name: "Fintech", url: "fintech" },
  //   { name: "Sports", url: "sports" },
  // ];

  //   console.log("tagUrl", tagUrl);
  const covertToText = (url) => {
    return url.replace(/_/g, " ");
  };

  const dataLoading = [1, 2, 3, 4];

  return (
    <div>
      {/* <HeroAlt
        title={tagUrl ? `News (${covertToText(tagUrl)})` : "News"}
        name="News"
      /> */}
      <HeaderImg title="News" />

      {/* <HorizontalAdv /> */}

      <div className="news__wrapper">
        <div className="news__alt__tags">
          {tagLoading ? (
            <Loading />
          ) : (
            <>
              <Link to={`/news`}>
                <span className={tagUrl === null ? "alt" : ""}>All</span>
              </Link>
              {tags?.tags?.map((tag) => {
                return (
                  <Link key={tag?.name} to={`/news?tag=${tag?.name}`}>
                    <span
                      className={
                        tagUrl === tag?.name?.replace(/ /g, "_") ? "alt" : ""
                      }
                    >
                      {tag?.name}
                    </span>
                  </Link>
                );
              })}
            </>
          )}
        </div>
        <div className="news__alt__main">
          {loading ? (
            <>
              {dataLoading?.map((item) => {
                return (
                  <div key={item} className="news__alt__main__item">
                    <div style={{ marginBottom: 10 }}>
                      <Skeleton height={150} />
                    </div>
                    <Skeleton count={4} />
                  </div>
                );
              })}
            </>
          ) : (
            <>
              {blogs?.map((item) => {
                return (
                  <Link key={item.id} to={`/news/${item?.slug}`}>
                    <div className="news__alt__main__item">
                      <div className="news__alt__main__item__img">
                        <img
                          src={process.env.REACT_APP_API_URL + item?.coverUrl}
                          alt=""
                        />
                      </div>
                      <div className="news__alt__main__item__cont">
                        <div className="news__alt__main__item__cont__top">
                          <Link
                            to={`/news?tag=${item?.tag?.replace(/ /g, "_")}`}
                          >
                            <span className="news__alt__main__item__cont__top__tag">
                              {item?.tag}
                            </span>
                          </Link>

                          <p>
                            <i className="bx bx-calendar-alt"></i>{" "}
                            {moment(item?.createdAt).format("Do MMM, YYYY")}
                          </p>
                        </div>

                        <h3 className="alt">
                          <LinesEllipsis
                            text={item?.title}
                            maxLine="2"
                            ellipsis="..."
                            trimRight
                            basedOn="letters"
                          />
                        </h3>

                        <p className="news__alt__main__item__cont__desc">
                          <LinesEllipsis
                            text={item?.summary}
                            maxLine="3"
                            ellipsis="..."
                            trimRight
                            basedOn="letters"
                          />
                        </p>
                      </div>
                    </div>
                  </Link>
                );
              })}
            </>
          )}
        </div>

        {data?.totalPages !== page && data?.totalPages !== 0 && (
          <div className="news__alt__btn">
            <button onClick={() => setPage((curr) => curr + 1)} className="btn">
              {loading ? <Loading button /> : "Load More"}
            </button>
          </div>
        )}
        {/* <div className="news__alt__btn">
          <button className="btnMain">View More</button>
        </div> */}
      </div>
    </div>
  );
};

export default News;
